module.exports = __webpack_public_path__ + "img/plan3.a02fefbf.svg";